module.exports = __webpack_public_path__ + "media/images/svg/logotype-outline-fa21e702b6da66bc79a32619734e7063.svg";